import React from 'react';
import DashboardContainer from '../containers/DashboardContainer';

const DashboardPage: React.FC = () => {
  return <DashboardContainer />;
};

export default DashboardPage;
